import React from "react"
import About from "./components/About"
import Navbar from "./components/Navbar"
import Projects from "./components/Projects"
import Skills from "./components/Skills"
import Social from "./components/Social"


export default function App() {
  return (
    <main className="text-gray-400 bg-slate-900 body-font">
      <Navbar />
      <About />
      <Projects />
      <Skills />
      <Social />
    </main>
  );
}